import { useQuery } from '@tanstack/react-query';

import { useBevoegdGezag } from '../bevoegdGezag';
import { BevoegdGezagSchemaObjectStatus } from '@/api/generated/digiVAPI.schemas';

const INGETROKKEN_STATUS =
  BevoegdGezagSchemaObjectStatus.IngetrokkenGepubliceerd;

const getOptions = () => {
  return useBevoegdGezag.getOptions({
    page: 1,
    size: 100,
    filter: [
      {
        model: 'BevoegdGezag',
        field: 'Volgend',
        op: 'is_null',
        value: '',
      },
      {
        field: 'ObjectStatus',
        op: 'ne',
        value: INGETROKKEN_STATUS,
      },
    ],
  });
};

const useActiveBevoegdGezagList = () => useQuery(getOptions());
useActiveBevoegdGezagList.getOptions = getOptions;

export { useActiveBevoegdGezagList };
